module.exports = __webpack_public_path__ + "media/day/332-2c2a308f.svg";